/* eslint-disable react/jsx-props-no-spreading */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import { Spacings } from '@styles/index';
import { goBack } from '@utils/breadcrumbs';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getOfflineSubscriptionUIDs } from '@api/selectors/subscription';

const TopBar = styled.div`
  margin-bottom: ${Spacings.SPACING_10B};
  transition: all 300ms ease;
`;

const Breadcrumbs = ({
  goalData,
  className,
  ctlgData,
  ctlgItemData,
  getTags,
  onBackClick
}) => {
  const list = useMyInfo(getOfflineSubscriptionUIDs);
  const isOfflineSubscription = list.includes(goalData.uid?.toUpperCase());
  const properties = {
    onBackClick,
    tags: getTags(goalData, ctlgData, ctlgItemData, isOfflineSubscription),
    useBackClick: true
  };
  return (
    <TopBar className={className}>
      <BreadCrumbs {...properties} />
    </TopBar>
  );
};

export default Breadcrumbs;
Breadcrumbs.propTypes = {
  goalData: PropTypes.objectOf(PropTypes.any),
  ctlgData: PropTypes.objectOf(PropTypes.any),
  ctlgItemData: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
  getTags: PropTypes.func.isRequired,
  onBackClick: PropTypes.func
};

Breadcrumbs.defaultProps = {
  goalData: {},
  className: '',
  ctlgData: {},
  ctlgItemData: {},
  onBackClick: goBack
};
